// ── Mock data for the Livestream Replay Library ──────────────────────────────
// In production these would come from the backend (NCB) after a stream ends and is
// archived. For now they mirror the mockLiveStreams shape with replay-specific fields.

export const replayStreams = [
  {
    id: 'replay-1',
    title: 'Celebration of Life: Eleanor Grace Thompson',
    organizer: 'Thompson Family',
    deceasedName: 'Eleanor Grace Thompson',
    familyName: 'Thompson',
    location: 'Willow Creek, OR',
    workPlace: 'Willow Creek Elementary',
    category: 'Educators',
    platform: 'youtube',
    embedId: 'dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?q=80&w=2076&auto=format&fit=crop',
    duration: '1h 24m',
    recordedDate: '2023-12-15',
    views: 1842,
    description: 'A full celebration of life service honouring Eleanor Thompson, beloved teacher and community pillar. Includes eulogies, musical tributes, and a candle-lighting ceremony.',
    featured: true,
  },
  {
    id: 'replay-2',
    title: 'Memorial Service: Marcus Aurelius Chen',
    organizer: 'Chen Estate',
    deceasedName: 'Marcus Aurelius Chen',
    familyName: 'Chen',
    location: 'San Francisco, CA',
    workPlace: 'Harbor View Bistro',
    category: 'Veterans',
    platform: 'youtube',
    embedId: 'dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?q=80&w=2070&auto=format&fit=crop',
    duration: '2h 03m',
    recordedDate: '2022-08-22',
    views: 967,
    description: 'Full naval honours memorial service for Captain Marcus Chen, held at the San Francisco Maritime Chapel. Features a 21-gun salute and bagpipe tribute.',
    featured: false,
  },
  {
    id: 'replay-3',
    title: "Artist's Tribute: Maya Lin Rodriguez",
    organizer: 'Brooklyn Arts Collective',
    deceasedName: 'Maya Lin Rodriguez',
    familyName: 'Rodriguez',
    location: 'Brooklyn, NY',
    workPlace: 'Vanguard Arts Hub',
    category: 'Artists',
    platform: 'facebook',
    streamUrl: 'https://www.facebook.com/facebook/videos/10153231339981729/',
    thumbnail: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?q=80&w=2080&auto=format&fit=crop',
    duration: '58m',
    recordedDate: '2024-02-10',
    views: 3104,
    description: 'A community art tribute featuring live mural painting in Maya Lin\'s style, storytelling from fellow artists, and a gallery walk of her most iconic works.',
    featured: true,
  },
  {
    id: 'replay-4',
    title: 'Evening Vigil: Sarah J. Miller',
    organizer: 'Miller Family',
    deceasedName: 'Sarah J. Miller',
    familyName: 'Miller',
    location: 'Chicago, IL',
    workPlace: 'Lakeside Elementary',
    category: 'Educators',
    platform: 'internal',
    thumbnail: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=2070&auto=format&fit=crop',
    duration: '45m',
    recordedDate: '2024-01-08',
    views: 521,
    description: 'An intimate candle-lit vigil held at Lakeside Elementary, where Sarah taught for 25 years. Current and former students shared memories and readings.',
    featured: false,
  },
  {
    id: 'replay-5',
    title: 'Remembrance Service: Robert Chen',
    organizer: 'Chen Estate',
    deceasedName: 'Robert Chen',
    familyName: 'Chen',
    location: 'San Francisco, CA',
    workPlace: 'Harbor View Bistro',
    category: 'Community',
    platform: 'youtube',
    embedId: 'dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?q=80&w=2076&auto=format&fit=crop',
    duration: '1h 12m',
    recordedDate: '2023-09-15',
    views: 743,
    description: 'A community remembrance for Chef Robert Chen, founder of Harbor View Bistro. Staff, family, and patrons shared stories and a final toast.',
    featured: false,
  },
  {
    id: 'replay-6',
    title: 'Memorial Concert: James Wilson',
    organizer: 'Wilson Family',
    deceasedName: 'James Wilson',
    familyName: 'Wilson',
    location: 'Nashville, TN',
    workPlace: 'Grand Ole Opry',
    category: 'Artists',
    platform: 'youtube',
    embedId: 'dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=2070&auto=format&fit=crop',
    duration: '2h 30m',
    recordedDate: '2023-11-04',
    views: 5621,
    description: 'A star-studded memorial concert celebrating the life of country music legend James Wilson. Performances by friends, family, and fellow artists.',
    featured: true,
  },
  {
    id: 'replay-7',
    title: 'Veterans Tribute: Col. Amelia Foster',
    organizer: 'Foster Family',
    deceasedName: 'Amelia Foster',
    familyName: 'Foster',
    location: 'Arlington, VA',
    workPlace: 'U.S. Air Force',
    category: 'Veterans',
    platform: 'facebook',
    streamUrl: 'https://www.facebook.com/facebook/videos/10153231339981729/',
    thumbnail: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?q=80&w=2070&auto=format&fit=crop',
    duration: '1h 45m',
    recordedDate: '2023-07-20',
    views: 2189,
    description: 'Full military honours burial service for Colonel Amelia Foster at Arlington National Cemetery. Flyover, flag presentation, and family eulogies.',
    featured: false,
  },
  {
    id: 'replay-8',
    title: 'Community Gathering: The Patterson Family',
    organizer: 'Patterson Estate',
    deceasedName: 'Henry & Margaret Patterson',
    familyName: 'Patterson',
    location: 'Portland, OR',
    workPlace: 'Portland General',
    category: 'Community',
    platform: 'internal',
    thumbnail: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?q=80&w=2070&auto=format&fit=crop',
    duration: '1h 08m',
    recordedDate: '2024-03-02',
    views: 384,
    description: 'A joint memorial celebrating the lives of Henry and Margaret Patterson, married 62 years. Family, neighbours, and church community shared stories.',
    featured: false,
  },
];

export const replayCategories = ['All', 'Educators', 'Veterans', 'Artists', 'Community'];